import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-aspect-ratio-on.tsx
/**
* icon.24.aspect-ratio.on
*
* Keywords: crop, corners, resize, frame, selection, transform, border, editing
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNSA3aC05YS41LjUgMCAwIDAtLjUuNXY5YS41LjUgMCAwIDAgLjUuNWg5YS41LjUgMCAwIDAgLjUtLjV2LTlhLjUuNSAwIDAgMC0uNS0uNW0tOS0xQTEuNSAxLjUgMCAwIDAgNiA3LjV2OUExLjUgMS41IDAgMCAwIDcuNSAxOGg5YTEuNSAxLjUgMCAwIDAgMS41LTEuNXYtOUExLjUgMS41IDAgMCAwIDE2LjUgNnptMi43MzIgNC4yMzJhLjUuNSAwIDEgMCAuNzA4LjcwNy41LjUgMCAwIDAtLjcwOC0uNzA3bTIuMTIyIDEuNDE0YS41LjUgMCAxIDAtLjcwOC43MDcuNS41IDAgMCAwIC43MDctLjcwN20xLjQxNCAxLjQxNWEuNS41IDAgMSAwLS43MDcuNzA2LjUuNSAwIDAgMCAuNzA3LS43MDZNOC41IDhhLjUuNSAwIDAgMC0uNS41djJhLjUuNSAwIDAgMCAxIDBWOWgxLjVhLjUuNSAwIDAgMCAwLTF6bTcuNSA1LjVhLjUuNSAwIDAgMC0xIDBWMTVoLTEuNWEuNS41IDAgMCAwIDAgMWgyYS41LjUgMCAwIDAgLjUtLjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=112-5475
*/
const Icon24AspectRatioOn = memo(function Icon24AspectRatioOn(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M16.5 7h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5m-9-1A1.5 1.5 0 0 0 6 7.5v9A1.5 1.5 0 0 0 7.5 18h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 6zm2.732 4.232a.5.5 0 1 0 .708.707.5.5 0 0 0-.708-.707m2.122 1.414a.5.5 0 1 0-.708.707.5.5 0 0 0 .707-.707m1.414 1.415a.5.5 0 1 0-.707.706.5.5 0 0 0 .707-.706M8.5 8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9h1.5a.5.5 0 0 0 0-1zm7.5 5.5a.5.5 0 0 0-1 0V15h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24AspectRatioOn };

//# sourceMappingURL=icon-24-aspect-ratio-on.js.map